import { createFileRoute } from '@tanstack/react-router';
import { LeadsList } from '../features/leads/LeadsList';

export const Route = createFileRoute('/leads/')({
  component: LeadsList,
});
